var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-desktop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    clipPath: "url(#clip-desktop)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15828",
    "data-name": "Group 15828",
    transform: "translate(-16186.141 4606.3) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_27077",
    "data-name": "Rectangle 27077",
    transform: "translate(-4572.639 -16223) rotate(90)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.72,
    height: 27.361,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31.72,
    height: 25.361,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27078",
    "data-name": "Rectangle 27078",
    width: 3.909,
    height: 11.726,
    rx: 1.954,
    transform: "translate(-4588.274 -16212.202)",
    fill: "#5c6d7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.187ff5ceeb728983d1adcda6019a7ae7.svg";
export { ForwardRef as ReactComponent };